export default "__VITE_ASSET__Dzjyjvlk__"